import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export const LEGAL_CONSENT_STORAGE_KEY = 'barter-bridge-legal-consent';

export interface LegalConsentPayload {
  version: string;
  termsAccepted: boolean;
  unusualClausesAccepted: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class LegalService {
  private readonly http = inject(HttpClient);

  acceptTerms(payload: LegalConsentPayload): Observable<unknown> {
    return this.http.post(`${environment.apiUrl}/legal/accept-terms`, {
      document_version: payload.version,
      terms_accepted: payload.termsAccepted,
      unusual_clauses_accepted: payload.unusualClausesAccepted,
    });
  }
}
